import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

import { PlateDetailV2Component } from './plate-detail-v2.component';
import { HeroGalleryComponent } from './components/hero-gallery/hero-gallery.component';
import { HeroActionsComponent } from './components/hero-actions/hero-actions.component';
import { MarketplaceComponent } from './components/marketplace/marketplace.component';
import { SimilarComponent } from './components/similar/similar.component';
import { PlatefolioComponent } from './components/platefolio/platefolio.component';
import { TimelineComponent } from './components/timeline/timeline.component';
import { MarketInfoComponent } from './components/market-info/market-info.component';
import { PhotoAddComponent } from './components/photo-add/photo-add.component';
import { HeroDescriptionComponent } from './components/hero-description/hero-description.component';

// Canonical <pla-plate> render (authentic PlateX plate font/asset) — reused
// rather than recreated, per the dev2 implementation principle.
import { PlateComponentModule } from '../../components/plate/plate.module';
// Canonical global nav chip row used across PlateX pages.
import { MainNavChipsModule } from '../../components/main-nav-chips/main-nav-chips.module';
// Shared PlateX classification pill (format/arrangement identity + deep link).
import { ClassificationPillModule } from '../../components/classification-pill/classification-pill.module';

@NgModule({
  declarations: [
    PlateDetailV2Component,
    HeroGalleryComponent,
    HeroActionsComponent,
    MarketplaceComponent,
    SimilarComponent,
    PlatefolioComponent,
    TimelineComponent,
    MarketInfoComponent,
    PhotoAddComponent,
    HeroDescriptionComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatIconModule,
    PlateComponentModule,
    MainNavChipsModule,
    ClassificationPillModule,
  ],
  exports: [PlateDetailV2Component],
})
export class PlateDetailV2Module {}
